import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IExtractSubtitleV1Params } from './extract-subtitle-v1-request';

export async function extractSubtitleV1Api({
  subtitleId,
  testRun,
  force,
}: IExtractSubtitleV1Params): Promise<Response> {
  const params: string[] = [];
  if (testRun) {
    params.push('testRun=true');
  }
  if (force) {
    params.push('force=true');
  }
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/extract/v1${query}`,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
